import { inject, provide } from "vue"
import { createTranslator } from "./i18n.js"

const CORE_I18N = Symbol("player-core-i18n")

/**
 * The page provides its translator (core keys + its own) once in setup; every PlayerCore
 * component injects it.
 */
export function provideCoreI18n(t) {
    provide(CORE_I18N, t)
}

export function useCoreI18n() {
    return inject(CORE_I18N, createTranslator("en"))
}
